<template>
    <asli-popup :show-close-button="false" :model-value="true">
        <div class="flex items-center justify-center flex-col pb-16">
            <img :src="logo" class="my-14 h-8 object-cover" />
            <p class="font-bold sm:text-xl pb-10 px-6 text-center" v-html="mainStore.loadingPopupText"></p>
            <asli-spinner />
        </div>
        <asli-interstitial />
    </asli-popup>
</template>

<script lang="ts" setup>
import { AsliPopup, AsliSpinner, AsliInterstitial } from "@mbs-npm/anpost-ui";
import logo from "@/assets/anpost-logo-green.png";
import { useMainStore } from "@/stores/main";

const mainStore = useMainStore();
</script>
